import React from "react";
//import {Set_ReactInternals_PolyfillAtOldPath} from "web-vcore/Dist/Utils/Store/ReactInternals.js";
// import JQuery from "../JQuery/JQuery3.1.0";

// include JQuery file directly from html, for faster building
//const JQuery = jQuery;

//Object.assign(window, {JQuery, jQuery: JQuery, $: JQuery}); declare global { const JQuery; /* const jQuery; const $; */ }
Object.assign(window, {React});

// make import of React unnecessary (`import * as React from "react";`)
// commented; this is now needed for other reasons (for typescript to interpret JSX as React.JSX types rather than JSX[global] types)
//declare global { const React: typeof React; }

// commented; this doesn't work in prod anyway
//Set_ReactInternals_PolyfillAtOldPath();